<template>
    <div class="rule-box">
        <van-nav-bar :title="title" left-text="返回" left-arrow @click-left="onClickLeft"/>
        <div class="content">
            <p>注：文件大小在400-600kb，支持 jpg 和 png 格式；</p>
            <!--<h4>上传证明材料 <span>*职称证明材料请上传图片</span></h4>
            <template v-if="!titleFileURL">
                <van-uploader
                        v-model="fileList"
                        :after-read="afterTitleFile"
                        @delete="delFile('titleFileId')"
                        :max-count="1"
                />
            </template>
            <template v-else>
                <van-uploader
                        v-model="fileList"
                        :after-read="afterTitleFile"
                        @delete="delFile('titleFileId')"
                        :max-count="1"
                >
                    <img :src="titleFileURL">
                </van-uploader>
            </template>-->
            <h4>2寸证件照<span>*照片仅用于制作会员证书</span></h4>
            <template v-if="!portraitURL">
                <van-uploader
                        v-model="fileList2"
                        :after-read="afterPortraitFile"
                        @delete="delFile('portraitId')"
                        :max-count="1"
                />
            </template>
            <template v-else>
                <van-uploader
                        v-model="fileList2"
                        :after-read="afterPortraitFile"
                        @delete="delFile('portraitId')"
                        :max-count="1"
                >
                    <img :src="portraitURL">
                </van-uploader>
            </template>
            <div class="buton">
                <van-button type="primary" size="large" @click="save">保存</van-button>
            </div>
        </div>

    </div>
</template>

<script>
    import vHead from "@/components/Subhead.vue";
    import { Uploader,Toast,Button,NavBar,Image ,Icon } from "vant";
    import { uploadFile, delFile } from "@/api/upload";
    import { getPZUrl,getUser} from "@/api/dictionary";
    import { mapState} from "vuex";
    import { registerMemberEdit } from "@/api/login";

    export default {
        data() {
            return {
                fileList: [],
                fileList2: [],
                photoList:[],
                uploadFileId:null,
                titleFileId: null,
                titleFileURL: "",
                titleName: "",
                portraitId: null,
                portraitURL: "",
                portraitName: "",
                title:"附件上传"
            };
        },
        components: {
            vHead,
            [Uploader.name]: Uploader,
            [Toast.name]: Toast,
            [Button.name]: Button,
            [NavBar.name]:NavBar,
            [Image.name]:Image ,
            [Icon.name]:Icon ,
        },
        methods: {
            beforeRead(file) {
                if (file.size / 1024 > 1024 * 6) {
                    Toast("上传头像图片大小不能超过 6M!");
                    return false;
                }
                return true;
            },
            delFile(type) {
                let id = this[type];
                this[type] = null;
                if (id) {
                    let params = {
                        id
                    };

                    delFile(params).then(res => {
                        if (res.success) {
                            Toast("删除成功");
                        } else {
                            Toast("删除失败");
                        }
                    });
                }
            },
            afterTitleFile(fileObj) {
                this.titleName =fileObj.file.name;
                let params = new FormData();
                params.append("file", fileObj.file);
                uploadFile(params).then(res => {
                    if (res.success) {
                        this.titleFileId = res.result.id;
                        Toast("上传成功");
                    } else {
                        Toast("上传失败");
                    }
                });
            },
            getImg() {
                if(this.portraitIda){
                    getPZUrl({ id: this.portraitIda })
                        .then(res => {
                            if (res.success) {
                                if (res.result) {
                                    this.portraitURL=res.result ;
                                } else {
                                    this.fileList = [];
                                }
                            }
                        })
                }
                if(this.titleFileIda) {
                    getPZUrl({id: this.titleFileIda})
                        .then(res => {
                            if (res.success) {
                                if (res.result) {
                                    this.titleFileURL=res.result;
                                } else {
                                    this.fileList = [];
                                }
                            }
                        })
                }
            },
            afterPortraitFile(fileObj) {
                this.portraitName =fileObj.file.name;
                let params = new FormData();
                params.append("file", fileObj.file);
                uploadFile(params).then(res => {
                    if (res.success) {
                        this.portraitId = res.result.id;
                        Toast("上传成功");
                    } else {
                        Toast("上传失败");
                    }
                });
            },
            save(){
                if(this.portraitId){
                    this.$router.push({name:"member",query:{source:1,titleFileId:this.titleFileId,portraitId:this.portraitId,titleName:this.titleName,portraitName:this.portraitName}});
                }else{
                    Toast("请上传图片");
                }
            },
            onClickLeft() {
                this.$router.push({name:"member",query:{source:1}});
            },
        },
        computed:{
            ...mapState(["userInfo"]),
            sendActiveRouter() {
                return this.$route.query && this.$route.query.sendActiveRouter;
            },
            titleFileIda() {
                return this.$route.query && this.$route.query.titleFileId;
            },
            portraitIda() {
                return this.$route.query && this.$route.query.portraitId;
            },
        },
        mounted() {
            let _this = this;
            getUser().then(res=>{
                if(res.success){
                    _this.getImg();
                }
            })
        },
    };
</script>

<style lang="less" scoped>
    p {
        margin-bottom: 10px;
    }
    b {
        font-weight: bold;
        margin-right: 10px;
    }
    ul {
        li {
            margin-bottom: 5px;
            line-height: 1.5;
        }
    }
    .content{
        padding:20px;
        .van-button--large{
            height:45px; line-height:35px; margin-top: 15px;
        }
        p{ font-size: 14px; color: #d64a4a; margin:10px 0;}
        h4{
            font-size: 15px; margin: 20px 0;
            span{color: #d64a4a;  font-size: 13px;}
        }
    }
    /deep/.van-uploader__upload,/deep/.van-uploader__preview,/deep/.van-uploader__preview-image
    { background: #f7f8fa; width: 100px; height: 100px;}
    .buton{ width: 80%; margin: 0 auto; margin-top: 20px;}
    .rule-box img{ max-width: 100%;}
</style>

